import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MtxDialogData } from '@ng-matero/extensions';
import { ChargerService } from 'app/shared/services/charger/charger.service';
import { DateService } from 'app/shared/services/utility/date.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

import {ViewEncapsulation} from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
//import {_rollupMoment} from 'moment';

const moment =  _moment;

export interface Log {
  action: string;
  charger_id : string ,
  charger_request : string,
  charger_response : string,
  request_date : string,
  response_date : string
}

@Component({
  selector: 'app-charger-log-shared-dialog',
  templateUrl: './charger-log-shared-dialog.component.html',
  styleUrls: ['./charger-log-shared-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations   : fuseAnimations
})
export class ChargerLogSharedDialogComponent implements OnInit {

  params: any;
  isEditMode = false;
  form: FormGroup;
  localStorage : any;
  status = false;

  batches:any;
  stations:any;
  versions :any;
  isAvailable = false;
  panelOpenState = false;
  minTDate : any;
  currDate : any = new Date();

  displayedColumns: string[] = ['action','charger_request','charger_response','request_date','response_date'];
  dataSource: MatTableDataSource<Log>;

  logs : Log[];

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  @ViewChild("toggleElement") ref: any;
  @ViewChild("toggleAvailable") toggleAvailable: any;


  constructor(private fb: FormBuilder,
   private chargerService : ChargerService,
    private dateService : DateService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<ChargerLogSharedDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: MtxDialogData) {}

  ngOnInit() {
    this.initialize();
  }

  initialize(){

    this.localStorage = JSON.parse( localStorage.getItem('userDetails'));

    this.params = this.data;
    
    // this.isEditMode = this.params.action == 'CREATE' ? false : true;

    this.form = this.fb.group({
      name: ['', ],
      serialNo: ['', [Validators.required]],
      batch: ['', [Validators.required]],
      station: ['', ],
      currentVersion: ['', [Validators.required]],
      noOfGuns: ['', [Validators.required]],
      address: ['', ],
      lat: ['', ],
      long: ['', ],
      otaConfig: ['', [Validators.required]],
      periodicCheckRefTime: ['', [Validators.required]],
      periodicityInHours: ['', [Validators.required]],
      whenToUpgrade: ['', [Validators.required]],
      upgradeSpecificTime: ['', [Validators.required]],
      isAvailable: ['', [Validators.required]],
      fromDate : [''],
      toDate : ['']
    });

    this.getChargerLogs();

    // if (this.isEditMode){
      this.assignValues(this.params);
    // }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


  getChargerLogs(){
    
    let formValues = this.form.value;

    let params = {
      charger_id : this.params.data.name,
      f_date : !!formValues.fromDate ? this.dateService.convertToYYYYMMDD(formValues.fromDate._d) : '',
      to_date : !!formValues.toDate ? this.dateService.convertToYYYYMMDD(formValues.toDate._d) : '',
      connector:"",
      //login_id:this.localStorage.userId
    }

    this.chargerService.getChargerLogs(this.localStorage.userId,params).subscribe((data:any)=>{
      //
        this.logs = data;
        //;

        if(this.logs.length>0){
          this.dataSource = new MatTableDataSource(this.logs);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }else{
          this.snackBar.open('No logs found', 'Dismiss', { duration: 3000 });
          this.dialogRef.close();
        }
    },(err)=>{
      
    })
  }

  close() {

    this.dialogRef.close();
  }


  search(){
    let formValues = this.form.value;
    
    
    const params: any = {
      charger_id : this.params.data.id,
      f_date : this.dateService.convertToYYYYMMDD(formValues.fromDate._d),
      t_date : this.dateService.convertToYYYYMMDD(formValues.toDate._d)
    }

    // if (this.isEditMode){
    //   params.id = this.params.data.id,
    //   params.modify_by = this.localStorage.userId;
    // } else{
    //   params.created_by = this.localStorage.userId;
    // }

    // if (this.isEditMode){
    this.chargerService.update(params).subscribe(
      (data: any ) => {
        
        this.snackBar.open('Record updated successfully!', 'Dismiss', { duration: 5000 });
        this.dialogRef.close();
      },
      (err) => {
        
        this.snackBar.open('Please try again', 'Dismiss', { duration: 5000 });
      }
    )
  // }else{
  //   this.chargerService.create(params).subscribe(
  //     (data: any ) => {
  //       
  //       this.snackBar.open('Charger created!', 'Dismiss', { duration: 5000 });
  //       this.dialogRef.close();
  //     },
  //     (err) => {
  //       
  //       this.snackBar.open('Please try again', 'Dismiss', { duration: 5000 });
  //     }
  //   )

  // }

    this.dialogRef.close(params);
  }

  getErrorMessage(form: FormGroup) {
    return form.get('email').hasError('required')
      ? 'You must enter a value'
      : form.get('email').hasError('email')
      ? 'Not a valid email'
      : '';
  }

  assignValues(params){
    
    this.form.get('name').setValue(params.data.name);
    this.form.get('serialNo').setValue(params.data.serial_no); 
    this.form.get('noOfGuns').setValue(params.data.no_of_guns); 
    this.form.get('address').setValue(params.data.Address); 
    this.form.get('lat').setValue(params.data.Lat); 
    this.form.get('long').setValue(params.data.Lng); 
    this.form.get('otaConfig').setValue(params.data.OTA_Config); 
    this.form.get('periodicCheckRefTime').setValue(this.dateService.refineDate(params.data.Periodic_Check_Ref_Time)); 
    this.form.get('periodicityInHours').setValue(params.data.Periodicity_in_hours); 
    this.form.get('whenToUpgrade').setValue(params.data.When_to_Upgrade); 
    this.form.get('upgradeSpecificTime').setValue(params.data.Upgrade_Specific_Time); 
  
    this.status = params.data.status == 'Y' ? true : false;
    this.isAvailable = params.data.is_available == 1 ? true : false;
  }

  updateStatus(event){
    this.status = event.checked;
    this.ref.checked = this.status;
  }

  updateAvailable(event){
    this.isAvailable = event.checked;
    this.toggleAvailable.checked = this.isAvailable;
  }

}






